

const scrollDiv = document.querySelector('.mega-menu.v-scrollable');

if (scrollDiv) {
    scrollDiv.addEventListener('scroll', function () {
        const mainInitDivs = document.querySelectorAll('.menu-sidebar__item .menu-sidebar__content');
        mainInitDivs.forEach(mainInitDiv => {
                mainInitDiv.style.top = '0px';
                mainInitDiv.style.transition = 'top 0.3s ease';
            });

       
        let scrollTop = scrollDiv.scrollTop; 

        console.log(scrollTop);
        const targetEls = document.querySelectorAll('.menu-sidebar__item .menu-sidebar__content');
        if (scrollTop > 159) {

            targetEls.forEach((targetEl, index) => {
                if(index > 9)
                {
                    targetEl.style.top = scrollTop+'px';
                    targetEl.style.transition = 'top 0.3s ease';
                }
                    
            });

       
        } 
        else{
            targetEls.forEach(targetEl => {
                targetEl.style.top = '0px';
                targetEl.style.transition = 'top 0.3s ease';
            });
        }
    });
}
